import React, { useMemo } from 'react'
import styled from 'styled-components'

import { Booth } from '../../types'
import StandLarge from './StandLarge'
import StandMedium from './StandMedium'
import StandSmall from './StandSmall'

const S = {
    Container: styled.div`
        display: block;
        width: 100%;
        height: 380px;
        padding: 10px 20px 20px;
        text-align: center;
    `,
}

export enum BoothTypes {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export interface BoothPreviewProps {
    background: string
    color: string
    logo: string
    video?: { url?: string }
    slug?: string
}

const BoothPreview = ({ booth }: { booth: Booth }) => {
    const props: BoothPreviewProps = {
        background: booth.image,
        logo: booth.booth_logo_url,
        color: booth.color,
        video: booth.videos.find((v) => v),
        slug: booth.slug
    }

    const Stand = useMemo(() => {
        switch (booth.type) {
        case BoothTypes.SMALL:
            return StandSmall
        case BoothTypes.MEDIUM:
            return StandMedium
        case BoothTypes.LARGE:
            return StandLarge
        default:
            return StandLarge
        }
    }, [booth.type])

    return (
        <S.Container className="flex-grow-0 flex-grow-0">
            <Stand {...props} />
        </S.Container>
    )
}

export default BoothPreview
